<template>
  <div class="group-page">
    <solution-banner :dataSouce="banner" />
    <div class="section">
      <div class="section-box bg-w">
        <div class="section-con">
          <h3 class="title">数字化营销转型面临的挑战</h3>
          <p class="subtitle">
            供需反转、渠道绑架、流量红利衰减越发成为地产营销卡脖子环节
          </p>
          <solution-card :dataSouce="card" />
        </div>
      </div>
      <div class="section-box bg-b">
        <div class="section-con">
          <h3 class="title">构建一体化的数字营销解决方案</h3>
          <solution-panel :dataSouce="panel" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from "./components/Banner.vue";
import SolutionCard from "./components/Card.vue";
import SolutionPanel from "./components/Panel.vue";
export default {
  name: "SolutionGroup",
  components: {
    SolutionBanner,
    SolutionCard,
    SolutionPanel,
  },
  data() {
    return {
      banner: [
        {
          image: "https://cdn.ideamake.cn/sw-pc/images/banner/banner-group-01.png",
          title: "三流合一的数字营销解决方案",
          link: "/index",
        },
       
      ],
      card: [
        {
          title: "业务流痛点",
          list: [
            "售前、售中、售后未打通",
            "策划、销售、渠道单兵作战",
            "判客系统僵化，无法灵活配置",
            "客储系统缺乏客户分层",
          ],
          icon: "https://cdn.ideamake.cn/sw-pc/images/card-icon-01.png",
        },
        {
          title: "数据流痛点",
          list: [
            "营销效果无法有效评估",
            "客户画像无法精准描摹",
            "业绩解码到执行过程纯线下，效率低",
            "数据缺乏治理，无法支持到BI系统应用",
          ],
          icon: "https://cdn.ideamake.cn/sw-pc/images/card-icon-02.png",
        },
        {
          title: "资金流痛点",
          list: [
            "结佣周期长速度慢",
            "全渠道效果分析未拉通",
            "末端投放能力未被构建",
          ],
          icon: "https://cdn.ideamake.cn/sw-pc/images/card-icon-03.png",
        },
      ],
      panel: [
        {
          direction: "left",
          title: "三流合一",
          subtitle:
            "以开发商能力为业务原点，打通集团-区域-城市-项目的业务流-数据流-资金流",
          link: "/index",
          list: [
            "业务流：拉通开发商业务全流程，实现场景导向的策销渠一体化和触达个人的千人千面体验",
            "数据流：打通客户全生命周期的数据链条，构建客户360画像",
            "资金流：打通智慧案场、全民营销，实现成交环节末端的交易管理和佣金灵活组合",
          ],
          image: "https://cdn.ideamake.cn/sw-pc/images/solution-01.png",
        },
        {
          direction: "right",
          title: "赋能一线",
          subtitle: "构建一体化的伙伴关系",
          link: "/index",
          list: [
            "通过多样化的机制、工具实现业绩赋能",
            "通过工作减负为末端提效，加快企业的业务策略执行",
          ],
          image: "https://cdn.ideamake.cn/sw-pc/images/solution-02.png",
        },
        {
          direction: "left",
          title: "数据驱动",
          subtitle: "无缝拉通业务联动和数据链路",
          link: "/index",
          list: [
            "建立从拓客-盘客-判客-跟进到成交全流程的营销闭环",
            "针对不同环节营销动作进行细粒度分析、沉淀",
            "沉淀官方私域流量，为营销主动转型积累数据资产",
            "打通数据孤岛，下放授权，释放组织活力",
          ],
          image: "https://cdn.ideamake.cn/sw-pc/images/solution-03.png",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.group-page {
  width: 100%;
  height: 100%;
  .section {
    width: 100%;
    height: 100%;
    
   
    &-box {
      width: 100%;
      height: 100%;
      padding: 80px 0;
     &.bg-w{
        background: #F7F9FB;
      }
      &.bg-b{
        background: #FFF;
      }
      .section-con {
        width: 1200px;
        margin: 0 auto;
        text-align: center;
      }
      .title {
        font-size: 32px;
        font-weight: 500;
        color: #2d2e30;
        padding-bottom: 20px;
      }
      .subtitle {
        font-size: 16px;
        font-weight: 400;
       
        padding-bottom: 60px;
        color: #5a5c60;
      }
    }
  }
}

// 移动端布局
@import "@/views/solution/min-solution";
</style>